import React from "react";
import { FC } from "react";
import { ComponentProps } from "react";
import { useMemo } from "react";
import { useRouteMatch } from "react-router";
import { LinkProps } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";
import { ButtonProps } from "@material-ui/core/Button";
import Link from "@material-ui/core/Link";
import { LinkBaseProps } from "@material-ui/core/Link";
import { ButtonBaseProps } from "@material-ui/core";
import Button from "./Button";
import { ButtonProps as MyButtonProps } from "./Button";

export const AdapterLink: FC<
  LinkBaseProps &
    LinkProps &
    ButtonProps &
    ButtonBaseProps &
    ComponentProps<any>
> = React.memo(
  React.forwardRef<any, any>((props, ref) => {
    const { path } = useRouteMatch();

    const { to, href, className: _className } = props;

    const isActive = useMemo(() => {
      if (to === "/0" || href === "/0") {
        return path === to || path === href;
      }
      return path.indexOf(to) === 0 || path.indexOf(href) === 0;
    }, [to, href, path]);

    const className = useMemo(
      () => (isActive ? _className + " active" : _className),
      [_className, isActive],
    );

    return (
      <Link
        component={to && RouterLink}
        innerRef={ref as any}
        {...props}
        className={className}
      />
    );
  }),
);

export const AdapterButton: FC<MyButtonProps & ComponentProps<any>> =
  React.memo(
    React.forwardRef<any, any>((props, ref) => (
      <Button
        color="secondary"
        variant="contained"
        innerRef={ref as any}
        component={RouterLink}
        {...props}
      />
    )),
  );

export const ApplyButton = React.memo(
  React.forwardRef<any, any>((props, ref) => (
    <Button
      size="large"
      color="success"
      variant="contained"
      innerRef={ref as any}
      component={RouterLink}
      {...props}
    />
  )),
);
